import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import { Url, URLS } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SuffixText from '../_partials/SuffixText';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';
export function usePointsBalanceItem() {
    const { t } = useTranslation();
    const { counts } = useContext(SessionContext);
    const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
    const isMobile = useContext(MobileContext);
    var _counts_points;
    return {
        label: t('siteHeaderMobile.userMenu.pointsBalance'),
        suffix: /*#__PURE__*/ React.createElement(SuffixText, null, numeral((_counts_points = counts === null || counts === void 0 ? void 0 : counts.points) !== null && _counts_points !== void 0 ? _counts_points : 0).format('0,0')),
        link: Url.buildFromPath(URLS.POINTS),
        biData: BiData({
            evid: 702,
            link_url: Url.buildFromPath(URLS.POINTS),
            menu_item: 'pointsBalance',
            menu_name: 'profile'
        }),
        tabIndex: isUserMenuOpen || !isMobile ? 0 : -1
    };
}

//# sourceMappingURL=usePointsBalanceItem.js.map